

class AssignmentModuleLogic {
  identificationEventModule; 
  appContext;
  framework;

  constructor(_identificationEventModule,_appContext,_framework) {
    this.identificationEventModule = _identificationEventModule;
    this.appContext = _appContext;
    this.framework = _framework;
  }

  async fetchMerchantAccountArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchMerchantAccountArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }   

  async fetchPosDeviceArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchPosDeviceArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }  
 
  async fetchDepositDeviceArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchDepositDeviceArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async fetchGatewayDeviceArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchGatewayDeviceArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async fetchSupervisorDeviceArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchSupervisorDeviceArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async fetchEcosystemDeviceArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchEcosystemDeviceArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async fetchStaffUserTypeArray(_condition,_successCallback,_errorCallback) {
    let appError = null;
    //const condition = "where status_id='ACT' order by role_code";
    const condition = _condition;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchStaffUserTypeArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }   
  
  async fetchStaffUserArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchStaffUserArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }     

  async fetchStaffUserAssignedArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where assigned_device_id is not null and status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchStaffUserArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }    

  async fetchStaffUserReturnedArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where assigned_device_id is null and assigned_devices_history is not null and status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchStaffUserArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async assignUserInfoToStaffUser(staffUserId,fullName,identityDocumentType,identityDocumentNumber,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const assignUserInfoToStaffUserRequest = {
      fullName: fullName,
	    identityDocumentType:identityDocumentType,
	    identityDocumentNumber:identityDocumentNumber,
      staffUserId: staffUserId,
    };    
    const response = await this.framework.getRestSystem().processAssignUserInfoToStaffUserRequest(assignUserInfoToStaffUserRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }    

  async assignDeviceToStaffUser(staffUserId,fullName,identityDocumentType,identityDocumentNumber,merchantAccountId,deviceType,deviceId,chargeType,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const assignDeviceToStaffUserRequest = {
      fullName: fullName,
	    identityDocumentType:identityDocumentType,
	    identityDocumentNumber:identityDocumentNumber,
	    merchantAccountId:merchantAccountId,
      deviceType: deviceType,
      deviceId: deviceId,
      staffUserId: staffUserId,
      chargeType:chargeType,
    };    
    console.log("assignDeviceToStaffUserRequest");
    console.log(assignDeviceToStaffUserRequest);
    const response = await this.framework.getRestSystem().processAssignDeviceToStaffUserRequest(assignDeviceToStaffUserRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }    
  
  async reassignDeviceToStaffUser(staffUserId,fullName,identityDocumentType,identityDocumentNumber,merchantAccountId,deviceType,deviceId,chargeType,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const reassignDeviceToStaffUserRequest = {
      fullName: fullName,
	    identityDocumentType:identityDocumentType,
	    identityDocumentNumber:identityDocumentNumber,
	    merchantAccountId:merchantAccountId,
      deviceType: deviceType,
      deviceId: deviceId,
      staffUserId: staffUserId,
      chargeType:chargeType,
    };   
    console.log("reassignDeviceToStaffUserRequest");
    console.log(reassignDeviceToStaffUserRequest);     
    const response = await this.framework.getRestSystem().processReassignDeviceToStaffUserRequest(reassignDeviceToStaffUserRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async assignEcosystemDeviceToStaffUser(staffUserId,staffUserTypeId,fullName,identityDocumentType,identityDocumentNumber,assignationConfigString,deviceId,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    
    const assignEcosystemDeviceToStaffUserRequest = {
      staffUserTypeId:staffUserTypeId,
      fullName: fullName,
	    identityDocumentType:identityDocumentType,
	    identityDocumentNumber:identityDocumentNumber,
      deviceId: deviceId,
      staffUserId: staffUserId,
      assignationConfigString:assignationConfigString,
    };    
    console.log("assignEcosystemDeviceToStaffUserRequest");
    console.log(assignEcosystemDeviceToStaffUserRequest);
    const response = await this.framework.getRestSystem().processAssignEcosystemDeviceToStaffUserRequest(assignEcosystemDeviceToStaffUserRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }    
  
  async reassignEcosystemDeviceToStaffUser(staffUserId,staffUserTypeId,fullName,identityDocumentType,identityDocumentNumber,assignationConfigString,deviceId,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const reassignEcosystemDeviceToStaffUserRequest = {
      staffUserTypeId:staffUserTypeId,
      fullName: fullName,
	    identityDocumentType:identityDocumentType,
	    identityDocumentNumber:identityDocumentNumber,
      deviceId: deviceId,
      staffUserId: staffUserId,
      assignationConfigString:assignationConfigString,
    };   
    console.log("reassignEcosystemDeviceToStaffUserRequest");
    console.log(reassignEcosystemDeviceToStaffUserRequest);     
    const response = await this.framework.getRestSystem().processReassignEcosystemDeviceToStaffUserRequest(reassignEcosystemDeviceToStaffUserRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }   
  
  async returnDevice(staffUserId,deviceType,deviceId,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const returnDeviceRequest = {
      staffUserId:staffUserId,
      deviceType: deviceType,
      deviceId: deviceId,
    };    
    const response = await this.framework.getRestSystem().processReturnDeviceRequest(returnDeviceRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    } 
  }

}




export default AssignmentModuleLogic;